import { DatevAuthCard } from '../components/DatevAuthCard';

export function Layout() {
  return (
    <div className="p-4 md:p-10 2xl:max-w-screen-2xl 2xl:mx-auto">
      <DatevAuthCard />
    </div>
  );
}
